/* React */
import React from "react";

/* Ionic */
import { ellipseOutline, radioButtonOn } from "ionicons/icons";

/* Components */
import CheckboxItem from "src/components/shared/checkbox-item/CheckboxItem";

/* Interfaces */
interface ConfidenceIntervalProps {
  showConfidenceIntervals: boolean;
  handleConfidenceIntervals: () => void;
}

const ConfidenceInterval: React.FC<ConfidenceIntervalProps> = ({
  showConfidenceIntervals,
  handleConfidenceIntervals,
}) => {
  return (
    <CheckboxItem
      label={"Show 95% confidence intervals"}
      icon={showConfidenceIntervals ? radioButtonOn : ellipseOutline}
      onClick={handleConfidenceIntervals}
    />
  );
};

export default ConfidenceInterval;
